module.exports = __webpack_public_path__ + "static/media/rank-2.070247a1.svg";